import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';

interface AcComponent {
    template: TemplateRef<any>;
    context: { [key: string]: any };
}

export interface UserMenuAction {
    message: string;
    acComponent?: AcComponent;
    callback?: Function;
}

export interface UserMenuSection {sectionTitle: string; sectionActions: UserMenuAction[]}

@Component({
    selector: 'ac-menu-options',
    templateUrl: './ac-menu-options.component.html',
    styleUrls: ['./ac-menu-options.component.less'],
})
export class AcMenuOptionsComponent {

    @Input() sections: UserMenuSection[];

    @Output() onAction: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    createActionClass = (name) => name.replace(' ', '-');
}
